'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (config, el) {
    if (config) {
        config.chart.renderTo = el || config.chart.renderTo;

        return new _highcharts2.default.Chart(config);
    }
};

var _highcharts = require('highcharts');

var _highcharts2 = _interopRequireDefault(_highcharts);

var _highchartsMore = require('highcharts-more');

var _highchartsMore2 = _interopRequireDefault(_highchartsMore);

var _highchartsSolidGauge = require('highcharts-solid-gauge');

var _highchartsSolidGauge2 = _interopRequireDefault(_highchartsSolidGauge);

var _highchartsNoDataToDisplay = require('highcharts-no-data-to-display');

var _highchartsNoDataToDisplay2 = _interopRequireDefault(_highchartsNoDataToDisplay);

var _highchartsExporting = require('highcharts-exporting');

var _highchartsExporting2 = _interopRequireDefault(_highchartsExporting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// apply
(0, _highchartsMore2.default)(_highcharts2.default);
(0, _highchartsSolidGauge2.default)(_highcharts2.default);
(0, _highchartsNoDataToDisplay2.default)(_highcharts2.default);
(0, _highchartsExporting2.default)(_highcharts2.default);

;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/generators/highcharts/index.js
 ** module id = 212
 ** module chunks = 0 1
 **/